import { formatCardKey } from '@/ai/utils/helpers'
import { buildPrompt } from '@/ai/utils/promptBuilder'
import { transformWorkflow } from '@/ai/utils/transformWorkflow'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'

export const buildSingleCardPrompt = ({
  eventId,
  workflow,
  cardTypes,
  cardTypeId
}) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []
  const cardType = cardTypes.find((cardType) => cardType.id === cardTypeId)
  const cardTypeTitle = cardType.title

  const { events, entities, eventIdToLongIdMap } = transformWorkflow(workflow)

  const event = events.find((e) => eventIdToLongIdMap[e.id] === eventId)

  promptSections.push({
    title: 'Request',
    content: [
      `Suggest one ${cardTypeTitle} (${cardType.description}) to be added
       to domain event ${event.id} (${event.role}: ${event.name}).`,
      `The ${cardTypeTitle} must be relevant to the workflow and the domain event as a whole and must not
       already exist in the workflow.`
    ]
  })

  promptSections.push({
    title: 'Current Workflow (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ domainEvents: events })
  })

  promptSections.push({
    title: 'Existing Entities (Optional): Use this information if applicable.',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ entities })
  })

  const cardExample = { [formatCardKey(cardTypeTitle)]: 'Example text' }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting(formatCardKey(cardTypeTitle), JSON.stringify(cardExample))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
